// import { useEffect, useState } from 'react';
// import GetData from '../../../services/GetData';
// import SkeletonLoader from '../SkeletonLoader/SkeletoLoader';
// import { zagTrader } from '../../../services/Requests';
// import { marketMoversTitle } from 'apps/frontend/services/ArabicTitles';
// import { useAppDispatch, RootState } from 'apps/frontend/store/Store';
// import { useSelector } from 'react-redux';
// import { getMarkets } from 'apps/frontend/reducers/MarketsSlice';
// import { setMarketMovers } from 'apps/frontend/reducers/MarketMoversSlice';
// import MarketMovers from './MarketMovers/MarketMovers';
// import {
//   marketsTimer,
//   marketsMoversTimer,
// } from 'apps/frontend/services/TimeVariables';
// import { requests, iraqIdentifier, iraqCode } from '../../../services/Requests';

// const SplitScreenBarCharts = () => {
//   const [wait, setWait] = useState(false);
//   const [marketID, setMarketID] = useState();

//   const dispatch = useAppDispatch();
//   const { marketsList, marketsTime, loading } = useSelector(
//     (state: RootState) => state.markets
//   );
//   const marketMovers = useSelector((state: RootState) => state.marketmovers);

//   // use of redux for markets menu
//   useEffect(() => {
//     const minutesInMilliseconds = marketsTimer?.minutesInMilliseconds;
//     const specificTimeAgo = Date.now() - minutesInMilliseconds;

//     marketsTime < specificTimeAgo && dispatch(getMarkets());
//   }, []);

//   useEffect(() => {
//     console.log('marketsList=>', marketsList);
//     marketsList &&
//       marketsList?.length &&
//       marketsList?.length > 0 &&
//       setMarketID(marketsList[0].marketId);
//   }, [marketsList]);

//   useEffect(() => {
//     if (marketID == 999) {
//       // IraqGainerLoser(marketID);
//     } else {
//       getMarketBarChartData(marketID);
//     }
//   }, [marketID]);

//   const IraqGainerLoser = (marketId) => {
//     setWait(true);

//     const minutesInMilliseconds = marketsMoversTimer?.minutesInMilliseconds;
//     const specificTimeAgo = Date.now() - minutesInMilliseconds;

//     const currentDate = new Date();
//     const currentTime = currentDate.getTime();

//     const data = {
//       Identifier: iraqIdentifier, // replace with actual identifier if dynamic
//       LanguageCode: iraqCode,
//     };
//     if (marketId > 0) {
//       if (
//         marketMovers[marketId]?.marketIdTime < specificTimeAgo ||
//         !(marketId in marketMovers)
//       ) {
//         GetData(`${requests.iraqGainerLoser}`, data, 'post', false)
//           .then((res) => {
//             // console.log("res=>",res.data[0])
//             const resp = res.data[0];
//             if (
//               (resp?.gainers && resp?.gainers?.length > 0) ||
//               (resp?.losers && resp?.losers?.length > 0)
//             ) {
//               const gainersList =
//                 resp?.gainers?.length > 5
//                   ? resp?.gainers.slice(0, 5)
//                   : resp?.gainers;
//               const losersList =
//                 resp?.losers?.length > 5
//                   ? resp?.losers.slice(0, 5)
//                   : resp?.losers;
//               const resultData = { gainers: gainersList, losers: losersList };

//               let marketMoversContainer = { ...marketMovers };
//               marketMoversContainer = {
//                 ...marketMoversContainer,
//                 [marketId]: { data: resultData, marketIdTime: currentTime },
//               };

//               dispatch(setMarketMovers(marketMoversContainer));
//             }
//             setWait(false);
//           })
//           .catch((err) => {
//             console.warn(err);
//           });
//       } else {
//         setWait(false);
//       }
//     }
//   };

//   const getMarketBarChartData = (marketId) => {
//     setWait(true);

//     const minutesInMilliseconds = marketsMoversTimer?.minutesInMilliseconds;
//     const specificTimeAgo = Date.now() - minutesInMilliseconds;

//     const currentDate = new Date();
//     const currentTime = currentDate.getTime();

//     if (marketId > 0) {
//       if (
//         marketMovers[marketId]?.marketIdTime < specificTimeAgo ||
//         !(marketId in marketMovers)
//       ) {
//         const glapi =
//           marketId == 100
//             ? `${zagTrader}api/GainerLoserAPI.php?langid=2&sectorId=32&marketId=100`
//             : `${zagTrader}api/GainerLoserAPI.php?marketId=${marketId}`;
//         GetData(glapi, {}, 'get', false)
//           .then((res) => {
//             if (
//               (res?.data?.gainers && res?.data?.gainers?.length > 0) ||
//               (res?.data?.losers && res?.data?.losers?.length > 0)
//             ) {
//               const gainersList =
//                 res?.data?.gainers?.length > 5
//                   ? res?.data?.gainers.slice(0, 5)
//                   : res?.data?.gainers;
//               const losersList =
//                 res?.data?.losers?.length > 5
//                   ? res?.data?.losers.slice(0, 5)
//                   : res?.data?.losers;
//               const resultData = { gainers: gainersList, losers: losersList };

//               let marketMoversContainer = { ...marketMovers };
//               marketMoversContainer = {
//                 ...marketMoversContainer,
//                 [marketId]: { data: resultData, marketIdTime: currentTime },
//               };

//               dispatch(setMarketMovers(marketMoversContainer));
//             }
//             setWait(false);
//           })
//           .catch((err) => {
//             setWait(false);
//             console.warn(err);
//           });
//       } else {
//         setWait(false);
//       }
//     }
//   };

//   useEffect(() => {
//     console.log('marketsList===>', marketsList);
//   }, [marketsList])


//   return (
//     <>
//       <div className="marketChart">
//         <div className="yellowTitle">
//           <h3>{marketMoversTitle}</h3>
//         </div>
//         <div className="chartBox">
//           <div className="chartTop">
//             <ul className="d-flex">
//               {loading && <SkeletonLoader />}
//               {
//                 // show bar chart menu
//                 marketsList?.length > 0 &&
//                 marketsList.map((item: any, index: number) => {
//                   return (
//                     <li key={index} className="nav-item">
//                       <a
//                         onClick={() => setMarketID(item?.marketId)}
//                         className={`nav-link ${item?.marketId === marketID ? 'active' : ''
//                           }`}
//                       >
//                         {item?.name ? item?.name : item?.marketArabicName}
//                       </a>
//                     </li>
//                   );
//                 })
//               }
//             </ul>
//           </div>

//           {wait && <SkeletonLoader count={5} />}

//           {!wait && marketID && marketID > 0 && (
//             <MarketMovers marketId={marketID} />
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default SplitScreenBarCharts;


import { useEffect, useRef, useState } from 'react';
import GetData from '../../../services/GetData';
import SkeletonLoader from '../SkeletonLoader/SkeletoLoader';
import { zagTrader } from '../../../services/Requests';
import { marketMoversTitle } from 'apps/frontend/services/ArabicTitles';
import { useAppDispatch, RootState } from 'apps/frontend/store/Store';
import { useSelector } from 'react-redux';
import { getMarkets } from 'apps/frontend/reducers/MarketsSlice';
import { setMarketMovers } from 'apps/frontend/reducers/MarketMoversSlice';
import MarketMovers from './MarketMovers/MarketMovers';
import {
  marketsTimer,
  marketsMoversTimer,
} from 'apps/frontend/services/TimeVariables';
import { requests, iraqIdentifier, iraqCode } from '../../../services/Requests';
import { parseApiResponse } from 'apps/frontend/services/parseZagApiResponse';

const SplitScreenBarCharts = () => {
  const [wait, setWait] = useState(false);
  const [marketID, setMarketID] = useState();
  const [connectionError, setConnectionError] = useState(false);
  const [userCountry, setUserCountry] = useState<any>({});
  const [isUserCountryLoaded, setIsUserCountryLoaded] = useState(false);
  const [isUserCountryFailed, setIsUserCountryFailed] = useState(false);
  const [isInitialMarketResolved, setIsInitialMarketResolved] = useState(false);
  const marketTabRefs = useRef<Record<string, HTMLLIElement | null>>({});

  const dispatch = useAppDispatch();
  const { marketsList, marketsTime, loading } = useSelector(
    (state: RootState) => state.markets
  );
  const marketMovers = useSelector((state: RootState) => state.marketmovers);

  // use of redux for markets menu
  useEffect(() => {
    const minutesInMilliseconds = marketsTimer?.minutesInMilliseconds;
    const specificTimeAgo = Date.now() - minutesInMilliseconds;

    marketsTime < specificTimeAgo && dispatch(getMarkets());
  }, []);

  useEffect(() => {
    console.log('marketsList===>', marketsList);
  }, [marketsList])
  

  const getUserCountry = () => {
    setIsUserCountryFailed(false);
    GetData(requests.usercountry, {}, 'get', false)
      .then((res) => {
        const resp = res?.data?.response || res?.data || {};
        setUserCountry(resp);
        setIsUserCountryLoaded(true);
      })
      .catch((err) => {
        console.warn(err);
        setIsUserCountryFailed(true);
        setUserCountry({});
        setIsUserCountryLoaded(true);
      });
  };

  useEffect(() => {
    getUserCountry();
  }, []);

  const getTargetMarketByCountry = (list: any[], country: any) => {
    const code = (country?.code || '').toUpperCase();
    const apiName = String(country?.name || '');
    const apiCity = String(country?.city || '');

    const normalizeText = (value: string) =>
      String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const displayNames = new Set<string>();
    if (apiName) {
      displayNames.add(apiName);
    }
    if (apiCity) {
      displayNames.add(apiCity);
    }

    if (code && typeof Intl !== 'undefined' && (Intl as any).DisplayNames) {
      try {
        const enName = new Intl.DisplayNames(['en'], { type: 'region' }).of(code);
        enName && displayNames.add(enName);
      } catch (_err) {}
    }

    const candidates = Array.from(displayNames)
      .map(normalizeText)
      .filter(Boolean);

    const getScore = (item: any) => {
      const marketEnglish = normalizeText(item?.marketEnglishName || '');
      const marketSymbol = normalizeText(item?.symbol || '');

      let score = 0;
      for (const candidate of candidates) {
        if (!candidate) continue;

        if (marketEnglish.includes(candidate) || candidate.includes(marketEnglish)) {
          score += 100;
        }

        const tokens = candidate.split(' ').filter((token) => token.length > 2);
        const tokenHits = tokens.filter(
          (token) => marketEnglish.includes(token) || marketSymbol === token
        ).length;
        score += tokenHits * 10;
      }

      return score;
    };

    const scoredMatches = list
      .map((item) => ({ item, score: getScore(item) }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score);

    if (scoredMatches.length) {
      return scoredMatches[0].item;
    }

    return list[0];
  };

  useEffect(() => {
    if (!isUserCountryLoaded || !marketsList?.length || isInitialMarketResolved) {
      return;
    }

    if (isUserCountryFailed) {
      setMarketID(marketsList[0]?.marketId);
      setIsInitialMarketResolved(true);
      return;
    }

    const matchedMarket = getTargetMarketByCountry(marketsList, userCountry);
    setMarketID((matchedMarket || marketsList[0])?.marketId);
    setIsInitialMarketResolved(true);
  }, [isUserCountryLoaded, marketsList, userCountry, isInitialMarketResolved, isUserCountryFailed]);

  useEffect(() => {
    if (marketID == 999) {
      // IraqGainerLoser(marketID);
    } else {
      // console.log('GETMARKET',marketID);
      getMarketBarChartData(marketID);
    }
  }, [marketID]);

  useEffect(() => {
    if (!marketID) return;
    const activeTab = marketTabRefs.current[String(marketID)];
    if (activeTab) {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [marketID]);

  const IraqGainerLoser = (marketId) => {
    setWait(true);
    setConnectionError(false);

    const minutesInMilliseconds = marketsMoversTimer?.minutesInMilliseconds;
    const specificTimeAgo = Date.now() - minutesInMilliseconds;

    const currentDate = new Date();
    const currentTime = currentDate.getTime();

    const data = {
      Identifier: iraqIdentifier, // replace with actual identifier if dynamic
      LanguageCode: iraqCode,
    };
    if (marketId > 0) {
      if (
        marketMovers[marketId]?.marketIdTime < specificTimeAgo ||
        !(marketId in marketMovers)
      ) {
        GetData(`${requests.iraqGainerLoser}`, data, 'post', false)
          .then((res) => {
            // console.log("res=>",res.data[0])
            const resp = res.data[0];
            if (
              (resp?.gainers && resp?.gainers?.length > 0) ||
              (resp?.losers && resp?.losers?.length > 0)
            ) {
              const gainersList =
                resp?.gainers?.length > 5
                  ? resp?.gainers.slice(0, 5)
                  : resp?.gainers;
              const losersList =
                resp?.losers?.length > 5
                  ? resp?.losers.slice(0, 5)
                  : resp?.losers;
              const resultData = { gainers: gainersList, losers: losersList };

              let marketMoversContainer = { ...marketMovers };
              marketMoversContainer = {
                ...marketMoversContainer,
                [marketId]: { data: resultData, marketIdTime: currentTime },
              };

              dispatch(setMarketMovers(marketMoversContainer));
            }
            setWait(false);
          })
          .catch((err) => {
            setWait(false);
            setConnectionError(true);
            console.warn(err);
          });
      } else {
        setWait(false);
      }
    }
  };

  const getMarketBarChartData = (marketId) => {
    setWait(true);
    setConnectionError(false);
    // console.log('marketID=>', marketId);
    const minutesInMilliseconds = marketsMoversTimer?.minutesInMilliseconds;
    const specificTimeAgo = Date.now() - minutesInMilliseconds;

    const currentDate = new Date();
    const currentTime = currentDate.getTime();

    if (marketId > 0) {
      if (
        marketMovers[marketId]?.marketIdTime < specificTimeAgo ||
        !(marketId in marketMovers)
      ) {
        // console.log('marketID=>', marketId);
        const glapi =
          marketId == 100
            ? `${zagTrader}api/GainerLoserAPI.php?langid=2&sectorId=32&marketId=100`
            : `${zagTrader}api/GainerLoserAPI.php?marketId=${marketId}`;
        GetData(glapi, {}, 'get', false)
          .then((res) => {
            const parsedRes = parseApiResponse(res?.data);
            if (
              (parsedRes?.gainers && parsedRes?.gainers?.length > 0) ||
              (parsedRes?.losers && parsedRes?.losers?.length > 0)
            ) {
              const gainersList =
                parsedRes?.gainers?.length > 5
                  ? parsedRes?.gainers.slice(0, 5)
                  : res?.data?.gainers;
              const losersList =
                parsedRes?.losers?.length > 5
                  ? parsedRes?.losers.slice(0, 5)
                  : parsedRes?.losers;
              const resultData = { gainers: gainersList, losers: losersList };

              let marketMoversContainer = { ...marketMovers };
              marketMoversContainer = {
                ...marketMoversContainer,
                [marketId]: { data: resultData, marketIdTime: currentTime },
              };

              dispatch(setMarketMovers(marketMoversContainer));
            }
            setWait(false);
          })
          .catch((err) => {
            setWait(false);
            setConnectionError(true);
            console.warn(err);
          });
      } else {
        setWait(false);
      }
    }
  };

  return (
    <>
      <div className="marketChart">
        <div className="yellowTitle">
          <h3>{marketMoversTitle}</h3>
        </div>
        <div className="chartBox">
          <div className="chartTop">
            <ul className="d-flex">
              {loading && <SkeletonLoader />}
              {
                // show bar chart menu
                marketsList?.length > 0 &&
                marketsList.map((item: any, index: number) => {
                  return (
                    <li
                      key={item.marketId}
                      className="nav-item"
                      ref={(el) => {
                        marketTabRefs.current[String(item.marketId)] = el;
                      }}
                    >
                      <a
                        onClick={() => setMarketID(item?.marketId)}
                        className={`nav-link ${item?.marketId === marketID ? 'active' : ''
                          }`}
                      >
                        {item.marketArabicName}
                      </a>
                    </li>
                  );
                })
              }
            </ul>
          </div>

          {wait && <SkeletonLoader count={5} />}

          {connectionError && !wait && (
            <div className="text-center py-2">
              <small>Connection error. Please try again.</small>
            </div>
          )}

          {!wait && marketID && marketID > 0 && (
            <MarketMovers marketId={marketID} />
          )}
        </div>
      </div>
    </>
  );
};

export default SplitScreenBarCharts;

